import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { APP_BASE_ROUTE, APP_ROUTES } from "../constants";
import {
  FriendsPage,
  GamePage,
  HomePage,
  IntroPage,
  RatingPage,
} from "../pages";
import UserContext from "./UserContext";
import { LoadingAnimation, TurnThePhone } from "../components";
import { NoDesktop } from "../components/NoDesktop";
import axios from "axios";
import { telegramMock } from "telegram.consts";
const webApp = window.Telegram.WebApp;
const platform = webApp.platform || "";
console.log();
const desktop = ["macos", "tdesktop", "weba", "web"].includes(webApp.platform);

export const LadybugLayout = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [startParam, setStartParam] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    console.log("[Ladybug.Init] > start");
    console.log("init", {
      initData: webApp.initData || "",
      version: webApp.version || "",
      platform: platform,
    });

    const urlParams = new URLSearchParams(window.location.search);
    const invitedBy = urlParams.get("invitedById");
    if (invitedBy) {
      console.log("[Ladybug.Init] > startParam: " + invitedBy);
    }

    if (webApp.isVersionAtLeast("6.1")) {
      webApp.setHeaderColor("#19151B");
      webApp.setBackgroundColor("#19151B");
      console.log("[Ladybug.Init] > set header color");
      console.log("[Ladybug.Init] > set background color");
    }
    if (webApp.isVersionAtLeast("6.2")) {
      webApp.enableClosingConfirmation();
      console.log("[Ladybug.Init] > enable closing confirmation");
    }
    if (webApp.isVersionAtLeast("7.7")) {
      webApp.disableVerticalSwipes();
      console.log("[Ladybug.Init] > disable vertical swipes");
    }

    axios
      .post("https://lovi-kwami.tv3.ru/api/ladybug-game/init", {
        initData: webApp.initData || "",
        version: webApp.version || "",
        platform: platform,
        invitedBy,
      })
      .then((response) => {
        response = response.data;
        console.log("response", response);
        const {
          telegram_user_id,
          username,
          last_name,
          first_name,
          photoPath,
          score,
          auth_token,
          guideCompleted,
          tasks,
          status,
        } = response.user;
        const _user = {
          telegram_id: telegram_user_id,
          username,
          lastName: last_name,
          firstName: first_name,
          coins: score,
          photo: photoPath,
          chatMember: status !== "kicked" && status !== "left",
          guideCompleted,
          authToken: auth_token,
          tasks,
        };

        console.log("[Ladybug.Init] > user: " + _user.username);
        setUser(_user);
      })
      .catch((error) => {
        console.error("[Ladybug.Init] > error", error);
        setError(true);
      })
      .finally(() => {
        console.log("[Ladybug.Init] > ready");
        setLoading(false);
        webApp.expand();
        webApp.ready();
      });
  }, []);

  // useEffect(() => {
  //   return () => {
  //     localStorage.removeItem('isFirstVisit');
  //   }
  // })

  if (loading) {
    console.log("Loading");
    return <LoadingAnimation />;
  }

  return (
    <UserContext.Provider value={{ user, setUser }}>
      <BrowserRouter basename={APP_BASE_ROUTE}>
        <Routes>
          <Route
            path={APP_ROUTES.INTRO}
            element={<IntroPage error={error} isChatMember={user.chatMember} />}
          />
          <Route
            path={APP_ROUTES.HOME}
            element={<HomePage startParamValue={startParam} />}
          />
          <Route path={APP_ROUTES.RATING} element={<RatingPage />} />
          <Route path={APP_ROUTES.FRIENDS} element={<FriendsPage />} />
          <Route path={APP_ROUTES.GAME} element={<GamePage />} />
        </Routes>
      </BrowserRouter>
      <TurnThePhone />
      {desktop && <NoDesktop />}
    </UserContext.Provider>
  );
};
